import classNames from "classnames";
import { Flip, toast } from "react-toastify";

import styles from "./styles.module.scss";

interface ToastMessageProps {
  description: string;
  title?: string;
}

const ToastMessage = ({ description, title }: ToastMessageProps) => {
  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.description}>{description}</div>
    </div>
  );
};

const commonSettings = {
  autoClose: 5000,
  className: styles.toast,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
  transition: Flip,
};

export const showErrorToast = (description: string, title?: string) => {
  toast.error(<ToastMessage description={description} title={title} />, {
    ...commonSettings,
    position: "bottom-right",
    className: classNames(styles.toast, styles.error),
  });
};

export const showSuccessToast = (description: string, title?: string) => {
  toast.success(<ToastMessage description={description} title={title} />, {
    ...commonSettings,
    className: classNames(styles.toast, styles.success, styles.top),
    autoClose: 3000,
    position: "top-right",
  });
};
